import { render, staticRenderFns } from "./ComplexCleaning.vue?vue&type=template&id=be683f48&scoped=true"
import script from "./ComplexCleaning.vue?vue&type=script&lang=js"
export * from "./ComplexCleaning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be683f48",
  null
  
)

export default component.exports